import router, { accessRoutes } from './router/index'
import store from './store/store'
import { getStore } from './config/storage'
import { workWeixinAuthURL } from './config/work_weixin'
import { qywxAuthLink } from './service/getData';
import authCode from '@/util/auth_code' //权限码获取
import { isMobile } from '@/util/index'
import Vue from 'vue';

export function isWxBrowser() {
  var ua = navigator.userAgent.toLowerCase();
  return (ua.match(/MicroMessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')
}

export function hasAuth(authName) {
  let value = authCode[authName]

  if (!authName || !value) {
    return true
  } else {
    let userInfo = getStore('costUserInfo')
    if (!userInfo) {
      return false
    }

    let code = value.pAuthCode

    if (value.platform == -1 && userInfo.dealer_id == 0 && userInfo.is_super_admin) {
      return true
    }

    // 判断权限所属平台 1 - 平台方， 2 - 中间商， 0 - 共用， -1 超级管理员
    if ((value.platform == 1 && userInfo.dealer_id > 0) || (value.platform == 2 && userInfo.dealer_id == 0) || value.platform == 3) {
      return false
    }

    let userAuthCodes = []
    let codes = userInfo.auth_codes
    if (codes && codes.length > 0) {
      userAuthCodes = codes[0].Codes
    }

    if (isMobile()) {
      code = value.mAuthCode
    }

    if (code == "") {
      return false
    }

    if (userInfo.is_super_admin) {
      return true
    }
    return userAuthCodes.includes(code)
  }
}

export function hasOneOfAuths(authNames) {
  var res = false
  for (let index = 0; index < authNames.length; index++) {
    const item = authNames[index];
    res = hasAuth(item)
    if (res) break
  }
  return res
}

const whiteList = ['/login', '/check_mobile', '/wechat/callback'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  let userInfo = getStore('costUserInfo')
  if (to.meta.authName) {
    if (!hasAuth(to.meta.authName)) {
      alert('权限不足')
      next({ path: '/dashboard' })
    }
  }

  if (to.meta.title == '404') {
    store.commit('logout')
    next({ path: '/login' })
    return
  }

  if (to.meta.title) {
    document.title = to.meta.title
  }

  if (to.path.indexOf('/sqs/') != -1 || to.path.indexOf('/service_orders/') != -1) {
    next()
    return
  }

  if (whiteList.indexOf(to.path) !== -1) {
    if (to.path == "/wechat/callback") {
      next()
      return
    }

    if (to.path == '/login' && userInfo) {
      next({ path: '/dashboard' })
    } else if (isWxBrowser() && (!to.query.wxcode || to.query.wxcode.length == 0)) {
      qywxAuthLink().then(res => {
        if (res.code == 0) {
          window.location.href = res.data
        }
      })
    } else {
      next()
    }
    return
  } else {
    if (!userInfo) {
      store.commit('loginRedirect', to.fullPath)
      next({ path: '/login' })
      return
    }
  }

  // if (!userInfo.loadRoute || !store.state.login) {
  //   const authRoutes = accessRoutes(userInfo.auths)
  //   router.addRoutes(authRoutes)
  //   userInfo.loadRoute = true
  //   store.commit('login', userInfo)
  //   next({ ...to, replace: true })
  // } else {
  //   store.commit('login', userInfo)
  // }
  store.commit('login', userInfo)

  Vue.prototype.FileToken = userInfo.token

  if (to.path == '/dashboard') {
    next({ path: '/dashboard/home' })
    // const dealer_id = store.state.userInfo.dealer_id
    // if (dealer_id == 0) {
    //   next({ path: '/dashboard/customers' })
    // } else {
    //   next({ path: '/dashboard/dealer/home' })
    // }
  } else {
    next()
  }
})
